import ENV_PARAMS from "./environment";

export const getVersion = () => {
  const isProd = ENV_PARAMS.PARTNER_PORTAL_ENV?.toLocaleLowerCase?.() === "prod";
  const version = import.meta.env.PARTNER_PORTAL_VERSION;
  const rcVersion = import.meta.env.PARTNER_PORTAL_RC_VERSION;
  return isProd ? version : rcVersion;
};
